module.exports = __webpack_public_path__ + "images/icons_v2/lock-outlined-d9aaf94a.svg";